import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import angularModule from 'Navigation/angularModule/scripts/navigation_module';

angularModule.factory('Navigation.ShareService', [
    '$injector',

    $injector => {
        const $window = $injector.get('$window');
        const EventLogger = $injector.get('EventLogger');
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const isMobile = $injector.get('isMobile');

        //-----------------------
        // Sharing Provider Meta
        //-----------------------

        const shareProviderMeta = {
            facebook: {
                serviceUrl: 'https://www.facebook.com/sharer/sharer.php',
                urlField: 'u',
                titleField: 't',
            },

            linkedin: {
                serviceUrl: 'http://www.linkedin.com/shareArticle',
                urlField: 'url',
                titleField: 'title',
                descriptionField: 'text',
                sourceField: 'source',
                additionalMeta: 'mini=true',
            },

            twitter: {
                serviceUrl: 'https://twitter.com/intent/tweet',
                sourceField: 'source',
                descriptionField: 'text',
                urlField: 'url',
            },

            email: {
                serviceUrl: 'mailto:',
                titleField: 'subject',
                descriptionField: 'body',
            },
        };

        function shareViaBrowser(shareLink) {
            let windowFeatures;
            if (!$window.CORDOVA) {
                const height = 350;
                const width = 450;
                const leftPosition = $window.screen.width / 2 - (width / 2 + 10);
                const topPosition = $window.screen.height / 2 - (height / 2 + 50);
                windowFeatures = `location=no,toolbar=no,status=no,height=${height},width=${width},resizable=yes,left=${leftPosition},top=${topPosition},screenX=${leftPosition},screenY=${topPosition},menubar=no,scrollbars=no,directories=no`;
            }
            NavigationHelperMixin.loadUrl(shareLink, '_blank', windowFeatures);
        }

        return {
            share(context, serviceName, shareInfo, logInfo) {
                const shareDetails = this.openShareWindow(serviceName, shareInfo);

                //---------------------------
                // Logging
                //---------------------------

                logInfo = logInfo || {};
                EventLogger.log(
                    'share',
                    angular.extend(
                        {
                            label: context,
                            service: serviceName,
                            campaign: shareDetails.campaignMedium,
                        },
                        logInfo,
                    ),
                );
            },

            shareMobileApp(shareInfo) {
                if (!Capacitor.isNativePlatform()) throw new Error('shareMobileApp() is for mobile app only');
                Share.share({ title: shareInfo.title, text: shareInfo.title, url: shareInfo.url }).catch(() => {});

                // FIXME: https://trello.com/c/ihn45kkM/925-feat-add-logging-support-to-cordova-shareservice-calls
            },

            openShareWindow(serviceName, shareInfo) {
                const meta = shareProviderMeta[serviceName];
                const shareDetails = angular.extend({}, shareInfo, shareInfo[serviceName]);

                //---------------------------
                // Share Info Validation
                //---------------------------

                if (!meta) {
                    throw new Error(`No sharing service for '${serviceName}' found`);
                }

                if (!shareDetails.url || !shareDetails.title) {
                    throw new Error(
                        'In order to perform a social sharing function, a URL and title must be specified at a minimum',
                    );
                }

                //---------------------------
                // Tracking Campaign Logic
                //---------------------------

                if (shareDetails.campaignDescription || shareDetails.campaignMedium) {
                    shareDetails.url += `${shareDetails.url.includes('?') ? '&' : '?'}utm_source=${encodeURIComponent(
                        serviceName,
                    )}`;

                    if (shareDetails.campaignMedium) {
                        shareDetails.url += `${'&utm_medium='}${encodeURIComponent(shareDetails.campaignMedium)}`;
                    }

                    if (shareDetails.campaignDescription) {
                        shareDetails.url += `&utm_campaign=${encodeURIComponent(shareDetails.campaignDescription)}`;
                    }

                    if (shareDetails.campaignContent) {
                        shareDetails.url += `&utm_content=${encodeURIComponent(shareDetails.campaignContent)}`;
                    }
                }

                //---------------------------
                // Common URL Fields
                //---------------------------

                const shareLink = `${meta.serviceUrl}?${meta.titleField}=${encodeURIComponent(shareDetails.title)}&${
                    meta.urlField ? `${meta.urlField}=${encodeURIComponent(shareDetails.url)}&` : ''
                }${meta.sourceField ? `${meta.sourceField}=${encodeURIComponent(shareDetails.url)}&` : ''}${
                    meta.descriptionField
                        ? `${meta.descriptionField}=${encodeURIComponent(shareDetails.description)}&`
                        : ''
                }${meta.additionalMeta ? `${meta.additionalMeta}&` : ''}`;

                //---------------------------
                // Special-Case Sharing
                //---------------------------

                if (serviceName === 'email' && isMobile()) {
                    // if mobile and email sharing, launch link directly (iOS popup is nicer)
                    $window.location = shareLink;
                } else {
                    shareViaBrowser(shareLink);
                }

                return shareDetails;
            },
        };
    },
]);
